import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-successdialog',
  templateUrl: './successdialog.component.html',
  styleUrls: ['./successdialog.component.css']
})
export class SuccessdialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/successdialog/successdialog.component.ts